import React from 'react'
import PropTypes from 'prop-types'
import { noop } from 'lodash'
import { Input, RadioGroup, Textarea } from 'formik-components'
import PhotoUploadField from './PhotoUploadField'
import { Question, QUESTION_TYPE } from 'types'

const propTypes = {
  question: Question.isRequired,
  isSubmitting: PropTypes.bool,
  onPhotoUploadAttempt: PropTypes.func,
  setCustomFormWideError: PropTypes.func,
  setFieldError: PropTypes.func,
}

const defaultProps = {
  isSubmitting: false,
  onPhotoUploadAttempt: noop,
  setCustomFormWideError: noop,
  setFieldError: noop,
}

// Renders a single API-described form field. Shared by the post-check-in questionnaire
// and the check-out form so a field looks and behaves the same wherever the backend
// places it.
function QuestionField({
  question,
  isSubmitting,
  onPhotoUploadAttempt,
  setCustomFormWideError,
  setFieldError,
}) {
  const {
    constraintText,
    constraints,
    fieldName,
    options,
    photoType,
    placeholder,
    questionId,
    required,
    title,
    type,
  } = question

  switch (type) {
    case QUESTION_TYPE.CHOICE:
      return (
        <RadioGroup
          name={fieldName}
          label={title}
          options={options}
          required={required}
          requiredIndicator="*"
        />
      )
    case QUESTION_TYPE.INPUT:
      return (
        <Input
          name={fieldName}
          label={title}
          required={required}
          requiredIndicator="*"
          type="text"
        />
      )
    case QUESTION_TYPE.TEXTAREA:
      return (
        <Textarea
          name={fieldName}
          label={title}
          type="textarea"
          autoGrow
          counter
          placeholder={placeholder}
          maxlength={constraints?.length?.maximum}
          required={required}
          requiredIndicator="*"
        />
      )
    case QUESTION_TYPE.PHOTO:
      return (
        <PhotoUploadField
          constraintText={constraintText}
          label={title}
          maxFiles={constraints?.length?.maximum}
          name={fieldName}
          photoType={photoType}
          required={required}
          requiredIndicator="*"
          isSubmitting={isSubmitting}
          questionId={questionId}
          onPhotoUploadAttempt={onPhotoUploadAttempt}
          shouldSetCustomFormWideError={true}
          setCustomFormWideError={setCustomFormWideError}
          setFieldError={setFieldError}
        />
      )
    default:
      throw new Error(`Unknown question type [${type}]`)
  }
}

QuestionField.propTypes = propTypes
QuestionField.defaultProps = defaultProps

export default QuestionField
